import React from 'react';
import DeviceLink from './DeviceLink';
import UndoRedo from './UndoRedo';
import PreviewButton from './PreviewButton';

import Desktop from './icons/Desktop';
import Tablet from './icons/Tablet';
import Phone from './icons/Phone';

import styles from '../../../../stylesheet/css/header-builder/toolbar.css';

const ToolBar = () => (
  <div className={styles.container}>
    <div className={styles.name}>
      <label className={styles.label}>My Beautiful Header</label>
    </div>
    <div className={styles.devices}>
      <div className={styles.devicesContainer}>
        <DeviceLink device="desktop" tooltiptext="Desktop"><Desktop /></DeviceLink>
        <DeviceLink device="tablet" tooltiptext="Tablet"><Tablet /></DeviceLink>
        <DeviceLink device="mobile" tooltiptext="Mobile"><Phone /></DeviceLink>
      </div>
    </div>
    <div className={styles.tools}>
      <PreviewButton />
      <UndoRedo />
    </div>
  </div>
);

export default ToolBar;


// WEBPACK FOOTER //
// ./app/header-builder/components/ToolBar.js